import React from 'react'
import { ReactSVG } from 'react-svg'

import { Grid, Container, Segment, Popup, Image } from 'semantic-ui-react'

import { themes } from '@/theme/context'
import { MobileOnlyGrid, TabletOnlyGrid, CustomImage, Link } from '@/components/OtherCustomComponents/style'
import { FullWidthBackgroundContainer, ThemedText, BodySegment, ListItem, BodyContainer, LeftBorderedSegmentList } from './style'

export const BodyComponent = ({ drupalHost }) => {
    return (<BodyContainer>
        <FullWidthBackgroundContainer>
            <Container>
                <BodySegment>
                    ФЭПО-pro проводится в&nbsp;форме онлайн-тестирования по&nbsp;аналогии с&nbsp;<b>Федеральным интернет-экзаменом в&nbsp;сфере профессионального образования (<Link href={'//fepo.' + drupalHost}>ФЭПО</Link>)</b> с&nbsp;применением технологии проведения <b>Федерального интернет-экзамена для&nbsp;выпускников бакалавриата (<Link href={'//bakalavr.' + drupalHost}>ФИЭБ</Link>).</b>
                </BodySegment>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <p>Оценка качества подготовки обучающихся, проведенная с&nbsp;помощью сервиса «{themes.fepo_pro.title}», может быть определена как вид внутренней системы оценки качества образования (<Link href="/node/1668">ВСОКО</Link>) и зачтена при&nbsp;прохождении государственных аккредитационных процедур контроля.</p>
            <p><ThemedText><b>Модель ПИМ</b></ThemedText></p>
            <p>Организатор тестирования может самостоятельно сформировать структуру педагогических измерительных материалов, включив в&nbsp;нее разделы и темы дисциплин, которые соответствуют содержанию рабочих программ. </p>
            <Grid stackable>
                <Grid.Row>
                    <Grid.Column>
                        Для&nbsp;формирования экзаменационного <b>полидисциплинарного</b> измерительного материала
                        из&nbsp;предложенного перечня необходимо выбрать <b>3 дисциплины</b>, включив в&nbsp;него:
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={8} verticalAlign='middle'>
                        <Image centered><ReactSVG src='/themes/defaultNiimko/images/fepo_pro/fepo_pro3.svg' /></Image>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <LeftBorderedSegmentList><b>не менее одной</b> дисциплины обязательной части ОПОП в&nbsp;соответствии с&nbsp;п. 2.2 ФГОС ВО: безопасность жизнедеятельности, иностранный язык (английский язык), история, философия</LeftBorderedSegmentList>
                        <LeftBorderedSegmentList><b>не менее одной</b> дисциплины обязательной части ОПОП <Link href="/node/1099">из&nbsp;предложенного перечня</Link> (за&nbsp;исключением дисциплин п. 2.2 ФГОС ВО)</LeftBorderedSegmentList>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <br/>
            <p><Link href="/fepo_pro_ocenka_rezultatov">Алгоритм и пример оценки результатов</Link></p>
        </Container>
        <FullWidthBackgroundContainer>
            <Container>
                <p><ThemedText><b>Укрупненные группы специальностей и направлений</b></ThemedText></p>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <ListItem><span>01.00.00</span><span>Математика и механика</span></ListItem>
                            <ListItem><span>02.00.00</span><span>Компьютерные и информационные науки</span></ListItem>
                            <ListItem><span>05.00.00</span><span>Науки о земле</span></ListItem>
                            <ListItem><span>07.00.00</span><span>Архитектура</span></ListItem>
                            <ListItem><span>08.00.00</span><span>Техника и технологии строительства</span></ListItem>
                            <ListItem><span>09.00.00</span><span>Информатика и вычислительная техника</span></ListItem>
                            <ListItem><span>10.00.00</span><span>Информационная безопасность</span></ListItem>
                            <ListItem><span>11.00.00</span><span>Электроника, радиотехника и системы связи</span></ListItem>
                            <ListItem><span>13.00.00</span><span>Электро- и теплоэнергетика</span></ListItem>
                            <ListItem><span>15.00.00</span><span>Машиностроение</span></ListItem>
                            <ListItem><span>19.00.00</span><span>Промышленная экология и биотехнологии</span></ListItem>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <ListItem><span>20.00.00</span><span>Техносферная безопасность и природообустройство</span></ListItem>
                            <ListItem><span>21.00.00</span><span>Прикладная геология, горное дело, нефтегазовое дело и геодезия</span></ListItem>
                            <ListItem><span>36.00.00</span><span>Ветеринария и зоотехния</span></ListItem>
                            <ListItem><span>37.00.00</span><span>Психологические науки</span></ListItem>
                            <ListItem><span>38.00.00</span><span>Экономика и управление</span></ListItem>
                            <ListItem><span>39.00.00</span><span>Социология и социальная работа</span></ListItem>
                            <ListItem><span>40.00.00</span><span>Юриспруденция</span></ListItem>
                            <ListItem><span>41.00.00</span><span>Политические науки и регионоведение</span></ListItem>
                            <ListItem><span>43.00.00</span><span>Сервис и туризм</span></ListItem>
                            <ListItem><span>44.00.00</span><span>Образование и педагогические науки</span></ListItem>
                            <ListItem><span>45.00.00</span><span>Языкознание и литературоведение</span></ListItem>
                            <ListItem><span>46.00.00</span><span>История и археология</span></ListItem>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <br/>
                <p><Link href="/fepo_pro_grafik">График проведения ФЭПО-pro</Link></p>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <Grid stackable>
                <Grid.Row>
                    <Grid.Column width={12}>
                        <p><ThemedText><b>Сертификаты ФЭПО-pro</b></ThemedText></p>
                        <p>Образовательным организациям по&nbsp;итогам успешного прохождения независимой оценки качества образования предоставляются <b>сертификаты качества.</b></p>
                    </Grid.Column>
                    <Grid.Column width={4} verticalAlign='middle'>
                        <Popup
                            content={<>Наличие сертификата качества может повлиять на&nbsp;позицию вуза в&nbsp;<Link target="_blank" href="//best-edu.ru/ratings/national/rejting-ocenka-kachestva-obrazovaniya">Национальном агрегированном рейтинге.</Link></>}
                            trigger={<Image src="/themes/fepo/images/fepo13.png" size='tiny' floated="left" />}
                            hideOnScroll={true}
                            style={{ fontSize: '18px' }}
                            size="huge"
                            wide={true}
                            hoverable={true}
                        />
                        <CustomImage $height="150px" src='/themes/defaultNiimko/images/fepo_pro/fepo_pro6.png' />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <br/>
            <p>Критерии для&nbsp;включения направления подготовки в&nbsp;сертификат качества</p>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <LeftBorderedSegmentList>
                            <b>суммарное количество именных золотых, серебряных, бронзовых сертификатов</b> ФЭПО-pro, полученных студентами вуза по&nbsp;данному направлению подготовки, составляет <b>не менее 50 %</b> от&nbsp;общего числа именных сертификатов для&nbsp;данного направления подготовки в&nbsp;вузе
                        </LeftBorderedSegmentList>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <LeftBorderedSegmentList>
                            в&nbsp;ФЭПО-pro по&nbsp;направлению подготовки принимали участие <b>не менее 10 студентов 2 курса</b>
                        </LeftBorderedSegmentList>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
        <FullWidthBackgroundContainer >
            <Container>
                <p>По&nbsp;итогам ФЭПО-pro вузу и студентам предоставляется доступ к&nbsp;именным сертификатам с&nbsp;указанием набранных баллов (процентов).<br/>
                Категории именных сертификатов студентов определяются на&nbsp;основании рейтинга <b>всех результатов</b> студентов конкретного направления подготовки по&nbsp;проценту набранных баллов.</p>
                <Grid stackable>
                    <Grid.Row columns={4}>
                        <Grid.Column textAlign="center">
                            <Image src="/themes/defaultNiimko/images/fepo_pro/fepo_pro2.png" centered size="tiny" />
                            золотые <br/>(<b>первые 10&nbsp;% студентов</b> в&nbsp;рейтинге)
                        </Grid.Column>
                        <Grid.Column textAlign="center">
                            <Image src="/themes/defaultNiimko/images/fepo_pro/fepo_pro5.png" centered size="tiny" />
                            серебряные (<b>следующие 15&nbsp;% студентов</b> в&nbsp;рейтинге)
                        </Grid.Column>
                        <Grid.Column textAlign="center">
                            <Image src="/themes/defaultNiimko/images/fepo_pro/fepo_pro1.png" centered size="tiny" />
                            бронзовые (<b>следующие 25&nbsp;% студентов</b> в&nbsp;рейтинге)
                        </Grid.Column>
                        <Grid.Column textAlign="center">
                            <Image src="/themes/defaultNiimko/images/fepo_pro/fepo_pro7.png" centered size="tiny" />
                            сертификаты участников (оставшиеся <b>50&nbsp;% студентов</b>)
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <br/>
                <p><b>Именные сертификаты студентов</b> по&nbsp;решению вуза или выпускающей кафедры могут учитываться при&nbsp;аттестации студента по&nbsp;дисциплине и определении категории стипендиальных выплат, дополняя портфолио.</p>
            </Container >
        </FullWidthBackgroundContainer >
        <Container>
            <Segment>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={13}>
                            <ThemedText><b>Педагогический анализ</b></ThemedText><br/>
                            ФЭПО-pro содержит количественные показатели участия образовательных организаций, количественные показатели участия вуза, анализ результатов тестирования студентов по&nbsp;направлениям подготовки с&nbsp;детализацией результатов выполнения конкретных заданий.
                        </Grid.Column>
                        <Grid.Column width={3} verticalAlign='middle'>
                            <CustomImage centered src='/themes/defaultNiimko/images/fepo_pro/fepo_pro4.png' $height="200px"/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        </Container>
        <Container>
            <TabletOnlyGrid>
                <Grid.Row columns={4}>
                    <Grid.Column textAlign="center">
                        <CustomImage src="/themes/defaultNiimko/images/fepo_pro/fepo_pro11.svg" centered size="tiny" />
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <CustomImage src="/themes/defaultNiimko/images/fepo_pro/fepo_pro8.svg" centered $width="66px" />
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <CustomImage src="/themes/defaultNiimko/images/fepo_pro/fepo_pro9.svg" centered size="tiny" />
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <CustomImage src="/themes/defaultNiimko/images/fepo_pro/fepo_pro10.svg" centered $width="44px"/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={4}>
                    <Grid.Column textAlign="center">
                        <b>Проверка соответствия аудиторий <Link href="/node/45#fepo-pro">техническим требованиям</Link></b><br/>
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <b>Заполнение плана тестирования</b>
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <b>Организация и проведение экзаменационного сеанса согласно графику</b><br/>
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <b>Получение результатов экзамена</b>
                    </Grid.Column>
                </Grid.Row>
            </TabletOnlyGrid>
            <MobileOnlyGrid stackable>
                <Grid.Row columns={4}>
                    <Grid.Column textAlign="center">
                        <CustomImage src="/themes/defaultNiimko/images/fepo_pro/fepo_pro11.svg" centered size="tiny" />
                        <b>Проверка соответствия аудиторий <Link href="/node/45#fepo-pro">техническим требованиям</Link></b>
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <CustomImage src="/themes/defaultNiimko/images/fepo_pro/fepo_pro8.svg" centered $width="66px" />
                        <b>Заполнение плана тестирования</b>
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <CustomImage src="/themes/defaultNiimko/images/fepo_pro/fepo_pro9.svg" centered size="tiny" />
                        <b>Организация и проведение экзаменационного сеанса согласно графику</b>
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                        <CustomImage src="/themes/defaultNiimko/images/fepo_pro/fepo_pro10.svg" centered $width="44px" />
                        <b>Получение результатов экзамена</b>
                    </Grid.Column>
                </Grid.Row>
            </MobileOnlyGrid>
            <br/>
            <p>С&nbsp;более подробной информацией о порядке проведения ФЭПО-pro можно ознакомиться в&nbsp;<Link href="/sites/default/files/fepo/fepo-pro/reglament_fepo-pro.pdf">Регламенте</Link>.</p>
        </Container >
    </BodyContainer>)
}